/**
 * @fileoverview Route for KOL Manager account activation via magic link
 * @module routes/activate-manager
 */

import type { ReactElement } from 'react';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { ManagerActivation } from '@/features/kol-managers/components/ManagerActivation';

interface ActivateManagerSearchParams {
  token?: string;
}

export const Route = createFileRoute('/activate-manager')({
  validateSearch: (search: Record<string, unknown>): ActivateManagerSearchParams => {
    return {
      token: search.token as string | undefined,
    };
  },
  component: ActivateManagerPage,
});

/**
 * Page component for KOL Manager activation.
 *
 * Validates the magic link token and allows wallet connection
 * to activate the manager account.
 *
 * @component
 */
function ActivateManagerPage(): ReactElement {
  const { token } = useSearch({ from: '/activate-manager' });

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Invalid Link</h1>
          <p className="text-gray-600">
            This activation link is invalid. Please check your email for the correct link.
          </p>
        </div>
      </div>
    );
  }

  return <ManagerActivation token={token} />;
}
